import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedInvoiceListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

type UseAthleteUpcomingInvoicesReturn = UseQueryResult<AxiosResponse<PaginatedInvoiceListList>> & {
  hasUpcomingInvoices: boolean;
};

export default function useAthleteUpcomingInvoices(
  athleteId: string | undefined,
): UseAthleteUpcomingInvoicesReturn {
  const query = useQuery(
    ['athleteUpcomingInvoices', athleteId],
    () => {
      const params: { athlete: string; available_for_items: string; limit: string } = {
        athlete: athleteId || '',
        available_for_items: 'true',
        limit: '1', // We only need to know if at least one exists
      };
      return client.get(`invoices/?${encodeUrlParams(params)}`);
    },
    {
      enabled: !!athleteId,
      retry: false,
      staleTime: 30000, // 30 seconds
    },
  );

  const hasUpcomingInvoices = (query.data?.data?.results?.length ?? 0) > 0;

  return {
    ...query,
    hasUpcomingInvoices,
  };
}
